import { Icons } from '@commenda/kakashi';

const EmptyState = () => (
  <div className="flex h-full flex-col items-center justify-center gap-md text-text-tertiary">
    <Icons.GitBranch01 className="size-8" />
    <p className="txt-small-medium text-text-primary">No structure yet</p>
    <p className="txt-extra-small-regular max-w-xs text-center">
      Add ownership relationships from each entity’s Owners tab to build your
      org diagram.
    </p>
  </div>
);

export { EmptyState };
